import PdfModal from './pdfModal';
export default PdfModal;
